module.exports = __webpack_public_path__ + "static/media/light_irancell_labz_logo.b1b4f001.svg";